var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"data-original-title":_vm.__(_vm.status),"data-placement":"top","data-toggle":"tooltip"},on:{"click":_vm.clickIcon}},[_c('span',{staticClass:"label",class:_vm.label},[_vm._v(_vm._s(_vm.acronym))])])}
var staticRenderFns = []

export { render, staticRenderFns }